var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image",style:(_vm.imageStyle)},[(!_vm.imageUrl)?_c('img',{class:'default',attrs:{"src":_vm.getImage('default/image-upload-icon.svg'),"alt":'Image'}}):_c('img',{style:({ borderRadius: _vm.types[_vm.imageType] }),attrs:{"src":_vm.imageUrl,"alt":'Image'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }